import { Cores } from 'src/componentes/styles/cores'
import styled from 'styled-components'

export const CorpoModal = styled.div`
  display: flex;
  flex-direction: column;
  padding: 24px;
  min-width: 480px;
  max-width: 560px;
`

export const TituloModal = styled.h5`
  margin-bottom: 16px;
  color: ${Cores.PRIMARIA_1};
`

export const AcoesModal = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 24px;
`
